import { render } from "./MsgBox.vue?vue&type=template&id=1495d65c&scoped=true"
import script from "./MsgBox.vue?vue&type=script&lang=js"
export * from "./MsgBox.vue?vue&type=script&lang=js"

import "./MsgBox.vue?vue&type=style&index=0&id=1495d65c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1495d65c"]])

export default __exports__